const Languages = [
	{
		"id": 0,
		"name": "Choose a Language",
		"code": "en"
	},
	{
		"id": 1,
		"name": "English",
		"code": "en"
	},
	{
		"id": 2,
		"name": "Arabic",
		"code": "ar"
	},
	{
		"id": 3,
		"name": "French",
		"code": "fr"
	},
	{
		"id": 4,
		"name": "German",
		"code": "de"
	},
	{
		"id": 5,
		"name": "Hindi",
		"code": "hi"
	},
	{
		"id": 6,
		"name": "Indonesian",
		"code": "in"
	},
	{
		"id": 7,
		"name": "Italian",
		"code": "it"
	},
	{
		"id": 8,
		"name": "Japanese",
		"code": "jp"
	},
	{
		"id": 9,
		"name": "Korean",
		"code": "ko"
	},
	{
		"id": 10,
		"name": "Malay",
		"code": "ms"
	},
	{
		"id": 11,
		"name": "Polish",
		"code": "pol"
	},
	{
		"id": 12,
		"name": "Portugese",
		"code": "pt"
	},
	{
		"id": 13,
		"name": "Russian",
		"code": "rus"
	},
	{
		"id": 16,
		"name": "Spanish",
		"code": "esp"
	},
	{
		"id": 15,
		"name": "Spanish (Mexico)",
		"code": "esm"
	},
	{
		"id": 17,
		"name": "Swedish",
		"code": "swe"
	},
	{
		"id": 18,
		"name": "Thai",
		"code": "tha"
	},
	{
		"id": 14,
		"name": "Chinese (Simplified)",
		"code": "zh"
	},
	{
		"id": 20,
		"name": "Chinese (Traditional)",
		"code": "zh-CHT"
	}
];

export { Languages };
